import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SearchField from '../../../home/components/filters/SearchField'
import FilterDateRangeV2 from '../../../home/components/filters/FilterDateRangeV2'
import FilterProductType from './FilterProductType'
import BatchesPartner from "./BatchesPartner"
import BatchesPartnerSew from "./BatchesPartnerSew"
import SelectFilterOptions from './../../../shared/SelectFilterOptions'
import NumberFilterOptions from './../../../shared/NumberFilterOptions'
import { BATCH_STATUS, BATCH_PRIORITY, RECEIVED_DATE, MERGE_STATUS, OPTIONS_OVERTIME, CUT_LASERS, MEX_OPTIONS, SEWED, TAGS, FORWARDED, LOCATIONS, CHEAP_PRODUCT } from './listOptions.json'
import { PRINT_QR, BATCH_EMBROIDERY } from "../../../../helpers/ListOptions.json"
import { Select, Input, Checkbox } from 'antd'
import FilterMaterials from './FilterMaterials'
import '../../styles/_BatchesFilter.scss'
import { getListProductionProcess } from '../../../../services/api/3dApi'
import FilterSkuPartner from '../../../shared/FilterSkuPartner'

class BatchesFilters extends Component {
    constructor(props) {
        super(props)
        const { typeOverTime } = props

        this.state = {
            printed_overtime: '',
            transferred_overtime: '',
            sewing_overtime: '',
            [typeOverTime]: 'yn',
            mex: '',
            isEmbroidery: false,
            listProductionProcess: [],
        }
    }
    _timeOut = null

    _fetchListProductionProcess = async () => {
        const payload = {
            page: 1,
            pageSize: 10000,
            name: 'thêu'
        }
        try {
            const { data: res } = await getListProductionProcess(payload)
            const { success, message: mess, data } = res || {}
            if (!success) {
                throw new Error(mess)
            }
            const { result = [] } = data || {}
            this.setState({ listProductionProcess: result })
        } catch (error) {
            console.log(error.message)
        }
    }

    componentDidMount() {
        this._fetchListProductionProcess()
    }

    _onchangeCheckbox = (field, e) => {
        const { listProductionProcess = [] } = this.state
        const { handleChangeInput } = this.props
        if (field === 'Thêu') {
            const newData = listProductionProcess.find(i => i.name.toLowerCase() === 'thêu')
            this.setState({
                isEmbroidery: e.target.checked ? (newData._id || '') : ''
            })
            handleChangeInput('production_process', e.target.checked ? (newData._id || '') : '')
        }
    }

    _handleChangeField = (field, value) => {
        const { handleChangeInput } = this.props
        if ([
            'brand',
            'batch_overtime',
            'mex',
            'sewed',
            'tags',
            'forwarded',
            'location',
            'presser_number',
            'is_cheap_product',
            'need_convert_cmyk',
            'printed_qr',
            'partner',
            'embroidery_batch_statistic',
            'production_partner',
        ].includes(field)) {
            handleChangeInput(field, value)
        } else {
            handleChangeInput(field, value.trim())
        }
    }

    _handleChangeFieldNew = (object) => {
        const { onChangeInputNew } = this.props
        onChangeInputNew(object)
    }

    _handleChangeName = (field, value) => {
        const { handleChangeInput } = this.props
        const newValues = value.trim().split(/,|\r|\n|\t|\r\n|\s|,\s|,/)

        if (typeof handleChangeInput === 'function') {
            handleChangeInput(field, [...new Set(newValues)])
        }
    }

    _handleChangeDate = (field, value) => {
        const { handleChangeDate } = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter[field] = value

        if (value.from === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverTime = (field, value) => {
        this.setState({
            [field]: value
        }, () => {
            const { handleChangeDate } = this.props
            const cloneFilter = Object.assign({}, this.props.filters)

            value !== 'days' && delete cloneFilter[field]

            switch (value) {
                case 'y':
                    cloneFilter[field] = { from: 0 }
                    break
                case 'yy':
                    cloneFilter[field] = { from: 0, phase_status: 'completed' }
                    break
                case 'yn':
                    cloneFilter[field] = { from: 0, phase_status: 'not_completed' }
                    break
                case 'n':
                    cloneFilter[field] = { to: 0 }
                    break
                default:
            }

            if (value !== 'days') {
                handleChangeDate(cloneFilter)
            } else if (typeof cloneFilter[field] === "object") {
                delete cloneFilter[field]['phase_status']
                delete cloneFilter[field]['from']
            }
        })
    }

    _handleChangeOverDayPrinted = (e) => {
        const { name, value } = e.target
        const { handleChangeDate } = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['printed_overtime'] = { ...cloneFilter['printed_overtime'], [name]: parseInt(value, 0) }

        if (value === null || value === '') {
            delete cloneFilter['printed_overtime'][name]
        }

        if (!cloneFilter['printed_overtime'].hasOwnProperty('from') && !cloneFilter['printed_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['printed_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverDayTransformed = (e) => {
        const { name, value } = e.target
        const { handleChangeDate } = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['transferred_overtime'] = { ...cloneFilter['transferred_overtime'], [name]: parseInt(value, 0) }

        if (value === null || value === '') {
            delete cloneFilter['transferred_overtime'][name]
        }

        if (!cloneFilter['transferred_overtime'].hasOwnProperty('from') && !cloneFilter['transferred_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['transferred_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverDaySewing = (e) => {
        const { name, value } = e.target
        const { handleChangeDate } = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['sewing_overtime'] = { ...cloneFilter['sewing_overtime'], [name]: parseInt(value, 0) }

        if (value === null || value === '') {
            delete cloneFilter['sewing_overtime'][name]
        }

        if (!cloneFilter['sewing_overtime'].hasOwnProperty('from') && !cloneFilter['sewing_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['sewing_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if (i !== 0) {
                const Option = {
                    name: i,
                    value: i,
                }
                if (i === -1) {
                    Options.push({ name: -1.5, value: -1.5, })
                }
                Options.push(Option)
            }
        }
        return Options
    }

    _handleChangeNote = (e) => {
        const { value } = e.target
        const { handleChangeInput } = this.props
        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            if (value.length >= 3 || !value) {
                handleChangeInput('note', value)
            }
        }, 500)
    }

    render() {
        const { printed_overtime, transferred_overtime, sewing_overtime, cut_lasers, mex, isEmbroidery } = this.state
        const { filters, onChangeProductType, showPartner, status, merge_file_status, listBrand, note, onChangeMaterials, listMaterials, isShowSewingPartner, onChangeCheckBox } = this.props
        const { level, batch_overtime, without_sewing_group = false } = filters
        const Option = Select.Option
        const disableNoBrand = !!filters.brand && filters.brand.length > 0 && !filters.brand.includes('no brand')
        const disableOptionBrand = !!filters.brand && filters.brand.length > 0 && filters.brand.includes('no brand')

        let optionPress = []
        for (let i = 0; i < 7; i++) {
            optionPress.push({
                name: `Máy ép ${i + 1}`,
                value: i + 1
            })
        }

        return (
            <div className='BatchesPageContainer'>
                <div className='row align-items-starts'>
                    <div className='FilterStatus col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={status}
                            value={filters.status}
                            isSewing={without_sewing_group === true}
                            listOptions={BATCH_STATUS}
                            style={{ width: '100%' }}
                            field="status" label="Trạng thái lô"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='FilterLevel col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={level}
                            style={{ width: '100%' }}
                            listOptions={BATCH_PRIORITY}
                            field="level" label="Độ ưu tiên"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Tên lô</label>
                        <SearchField
                            field='name'
                            placeholder='Tìm kiếm theo tên Lô...'
                            onChangeInput={this._handleChangeName}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Người tạo lô</label>
                        <SearchField
                            field='user_create'
                            placeholder='Tìm kiếm theo người tạo ...'
                            onChangeInput={this._handleChangeField}
                        />
                    </div>

                    <div className='col-12 col-xl-4 mb-3'>
                        <label className="font-weight-bold d-block">Loại sản phẩm</label>
                        <FilterProductType
                            productTypes={filters.product_types}
                            onChangeProductType={onChangeProductType}
                        />
                    </div>


                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày tạo lô</label>
                        <FilterDateRangeV2 
                            field='created_at' 
                            filters={filters} 
                            onDatesChange={this._handleChangeDate} 
                            showTime 
                            isDisableData={true}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày ép</label>
                        <FilterDateRangeV2 field='transferred_at' filters={filters} onDatesChange={this._handleChangeDate} showTime />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày in lô</label>
                        <FilterDateRangeV2 field='printed_at' filters={filters} onDatesChange={this._handleChangeDate} showTime />
                    </div>
                    {
                        showPartner && (
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày giao may</label>
                                <FilterDateRangeV2 field='sewing_at' filters={filters} onDatesChange={this._handleChangeDate} showTime />
                            </div>
                        )
                    }

                    {
                        showPartner && (
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày nhận may</label>
                                <FilterDateRangeV2 field='receive_sew_at' filters={filters} onDatesChange={this._handleChangeDate} showTime />
                            </div>
                        )
                    }

                    {showPartner && <BatchesPartner onChangePartner={this._handleChangeField} />}

                    {
                        showPartner &&
                        <BatchesPartnerSew
                            onChangePartner={this._handleChangeFieldNew}
                            isSewingGroup={without_sewing_group}
                            isShowSewingPartner={isShowSewingPartner}
                            onChangeCheckBox={onChangeCheckBox}
                            status={filters.status}
                            filters={filters}
                            disabled={(filters.production_partner || []).length > 0}
                        />
                    }

                    {
                        showPartner && (
                            <div className='FilterLevel col-12 col-xl-2 mb-3'>
                                <SelectFilterOptions
                                    defaultValue={level}
                                    style={{ width: '100%' }}
                                    listOptions={RECEIVED_DATE}
                                    field="sewing_time_type" label="Ngày nhận may"
                                    handleChange={this._handleChangeField}
                                />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={merge_file_status}
                            listOptions={MERGE_STATUS}
                            style={{ width: '100%' }}
                            field="merge_file_status" label="Trạng thái gộp"
                            handleChange={this._handleChangeField}
                        />
                    </div>


                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={printed_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{ width: '100%' }}
                            field="printed_overtime" label="Thời gian quá hạn In"
                            handleChange={this._handleChangeOverTime}
                        />
                    </div>

                    {
                        printed_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='from'
                                    placeholder="từ"
                                    defaultValue={filters.printed_overtime !== undefined ? filters.printed_overtime.from : ''}
                                    handleChange={this._handleChangeOverDayPrinted}
                                />
                            </div>
                        )
                    }

                    {
                        printed_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='to'
                                    placeholder="đến"
                                    defaultValue={filters.printed_overtime !== undefined ? filters.printed_overtime.to : ''}
                                    handleChange={this._handleChangeOverDayPrinted}
                                />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={transferred_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{ width: '100%' }}
                            field="transferred_overtime"
                            label="Thời gian quá hạn Ép"
                            handleChange={this._handleChangeOverTime}
                        />
                    </div>

                    {
                        transferred_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='from'
                                    placeholder="từ"
                                    defaultValue={filters.transferred_overtime !== undefined ? filters.transferred_overtime.from : ''}
                                    handleChange={this._handleChangeOverDayTransformed}
                                />
                            </div>
                        )
                    }

                    {
                        transferred_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='to'
                                    placeholder="đến"
                                    defaultValue={filters.transferred_overtime !== undefined ? filters.transferred_overtime.to : ''}
                                    handleChange={this._handleChangeOverDayTransformed} />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={sewing_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{ width: '100%' }}
                            field="sewing_overtime"
                            label="Thời gian quá hạn May"
                            handleChange={this._handleChangeOverTime}
                        />
                    </div>

                    {
                        sewing_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='from'
                                    placeholder="từ"
                                    defaultValue={filters.sewing_overtime !== undefined ? filters.sewing_overtime.from : ''}
                                    handleChange={this._handleChangeOverDaySewing}
                                />
                            </div>
                        )
                    }

                    {
                        sewing_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='to'
                                    placeholder="đến"
                                    defaultValue={filters.sewing_overtime !== undefined ? filters.sewing_overtime.to : ''}
                                    handleChange={this._handleChangeOverDaySewing}
                                />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={cut_lasers}
                            listOptions={CUT_LASERS}
                            style={{ width: '100%' }}
                            field="cut_lasers"
                            label="Cắt laze"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <div className="SelectFilterOption">
                            <label htmlFor="request_update" className="d-block w-100 font-weight-bold">Brand</label>
                            <Select
                                name='brand'
                                className='brand'
                                mode={'multiple'}
                                onChange={(value) => this._handleChangeField('brand', value)}
                                value={filters.brand}
                                allowClear
                                placeholder='Chọn brand name'
                                style={{ width: '100%', maxWidth: '460px' }}
                            >
                                <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                {listBrand && listBrand.length && listBrand.map((i, index) => (
                                    <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                ))
                                }
                            </Select>
                        </div>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={batch_overtime}
                            listOptions={this.getOptionOverTime(-6, 6)}
                            style={{ width: '100%' }}
                            field="batch_overtime" label="Thời gian item quá hạn"
                            handleChange={this._handleChangeField}
                            mode='multiple'
                            showArrow
                            allowClear
                            placeholder='Chọn thời gian item quá hạn'
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={mex || []}
                            listOptions={MEX_OPTIONS}
                            style={{ width: '100%' }}
                            field="mex" label="Ép mex"
                            placeholder='Chọn ép mex'
                            allowClear
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={'all'}
                            listOptions={SEWED}
                            style={{ width: '100%' }}
                            field="sewed" label="Trạng thái đã may xong"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Thời điểm may xong</label>
                        <FilterDateRangeV2 field='sewed_at' filters={filters} onDatesChange={this._handleChangeDate} showTime />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={[]}
                            mode="tags"
                            listOptions={TAGS}
                            style={{ width: '100%' }}
                            field="tags" label="Tags"
                            placeholder='Chọn tag'
                            allowClear
                            handleChange={this._handleChangeField}
                            isMultiple={true}
                        />
                    </div>

                    <div className='FilterStatus col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={''}
                            listOptions={FORWARDED}
                            style={{ width: '100%' }}
                            field="forwarded" label="Đã giao"
                            handleChange={this._handleChangeField}
                        />
                    </div>
                    <div className='FilterStatus col-12 col-xl-2 mb-3'>
                        <div className='SelectFilterOption'>
                            <label className="font-weight-bold d-block">Note</label>
                            <Input.TextArea
                                field='note'
                                defaultValue={note}
                                autoSize={{ minRows: 1, maxRows: 5 }}
                                placeholder='Tìm kiếm theo ghi chú...'
                                onChange={this._handleChangeNote}
                                allowClear
                            />
                        </div>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Nguyên vật liệu</label>
                        <FilterMaterials
                            listOptions={listMaterials}
                            materials={filters.materials}
                            onChangeMaterials={onChangeMaterials}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={[]}
                            // mode="multiple"
                            listOptions={LOCATIONS}
                            style={{ width: '100%' }}
                            field="location" label="Địa điểm sản xuất"
                            placeholder='Chọn địa điểm sản xuất'
                            allowClear
                            handleChange={this._handleChangeField}
                            isMultiple={true}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={[]}
                            listOptions={optionPress}
                            style={{ width: '100%' }}
                            field="presser_number" label="Máy ép"
                            placeholder='Chọn máy ép'
                            allowClear
                            handleChange={this._handleChangeField}
                            isMultiple={true}
                            mode={'multiple'}
                        />
                    </div>

                    <div className='FilterStatus col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={''}
                            listOptions={CHEAP_PRODUCT}
                            style={{ width: '100%' }}
                            field="is_cheap_product" label="Sản phẩm giá rẻ"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='FilterStatus col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={''}
                            listOptions={FORWARDED}
                            style={{ width: '100%' }}
                            field="need_convert_cmyk" label="Convert CMYK"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='FilterStatus col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={filters.printed_qr || []}
                            listOptions={PRINT_QR}
                            style={{ width: '100%' }}
                            field="printed_qr" label="In QR"
                            handleChange={this._handleChangeField}
                            placeholder='Chọn in QR'
                            allowClear
                        />
                    </div>
                    {
                        isEmbroidery &&
                        <div className='col-12 col-xl-2 mb-3'>
                            <label className="font-weight-bold d-block">Thời gian thiết kế thêu</label>
                            <FilterDateRangeV2
                                field='designed_at'
                                filters={filters}
                                onDatesChange={this._handleChangeDate}
                                showTime
                            />
                        </div>
                    }
                    <FilterSkuPartner
                        value={filters.production_partner || []}
                        onChange={(value) => this._handleChangeField('production_partner', value)}
                        disabled={
                            (filters.without_sewing_group || false) ||
                            (filters.without_sewing_partner || false) ||
                            ((filters.mutiple_sewing_partner || []).length > 0)
                        }
                    />
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block" style={{ height: 21 }}></label>
                        <div className='embroidery-filter d-flex align-items-center justify-content-between' style={{ height: 32 }}>
                            <Checkbox checked={!!isEmbroidery} className='font-weight-bold' onChange={(e) => this._onchangeCheckbox('Thêu', e)}>Thêu</Checkbox>
                            {
                                isEmbroidery &&
                                <div className='FilterStatus select-embroidery' style={{marginBottom: '30px'}}>
                                    <SelectFilterOptions
                                        defaultValue={filters.embroidery_batch_statistic || []}
                                        listOptions={BATCH_EMBROIDERY}
                                        style={{ width: '100%' }}
                                        field="embroidery_batch_statistic" label="Lô thêu"
                                        handleChange={this._handleChangeField}
                                        placeholder='Chọn lô thêu'
                                        allowClear
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

BatchesFilters.defaultProps = {
    showPartner: true
}

BatchesFilters.propTypes = {
    showPartner: PropTypes.bool,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    handleChangeInput: PropTypes.func.isRequired,
    onChangeProductType: PropTypes.func.isRequired
}

export default BatchesFilters
